"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var utils_1 = require("./utils");
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var spaui_1 = require("@tencent/spaui");
var info_1 = __importDefault(require("./info"));
var returnTrue = function returnTrue() {
  return true;
};
var LabelInputComponent = function LabelInputComponent(props, ref) {
  var _a = props.size,
    size = _a === void 0 ? 'mini' : _a,
    _b = props.onlyLabelDisplay,
    onlyLabelDisplay = _b === void 0 ? false : _b,
    _c = props.disabled,
    disabled = _c === void 0 ? false : _c,
    onChange = props.onChange,
    _d = props.data,
    data = _d === void 0 ? [] : _d,
    _e = props.separator,
    separator = _e === void 0 ? '，' : _e,
    _f = props.validate,
    validate = _f === void 0 ? returnTrue : _f,
    _g = props.separatorReg,
    separatorReg = _g === void 0 ? null : _g,
    placeholder = props.placeholder,
    inputPlaceholder = props.inputPlaceholder,
    _h = props.clear,
    clear = _h === void 0 ? true : _h,
    _j = props.LabelClear,
    labelClear = _j === void 0 ? false : _j,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    borderClassName = props.borderClassName,
    fromGroupClassName = props.FromGroupClassName,
    labelsClassName = props.LabelsClassName,
    setItemClassName = props.setItemClassName,
    _k = props.errorTips,
    errorTips = _k === void 0 ? null : _k,
    tipRender = props.tipRender,
    _l = props.blurTransValueIntoLabel,
    blurTransValueIntoLabel = _l === void 0 ? false : _l,
    FormGroupProps = props.FormGroupProps,
    // eslint-disable-line
    LabelsProps = props.LabelsProps;
  var _m = __read((0, react_1.useState)(false), 2),
    editable = _m[0],
    setEditable = _m[1];
  var _o = __read((0, react_1.useState)(''), 2),
    inputValue = _o[0],
    setInputValue = _o[1];
  var _p = __read((0, react_1.useState)(null), 2),
    inputErrorMsg = _p[0],
    setInputErrorMsg = _p[1];
  var inputRef = (0, react_1.useRef)(null);
  var formGroupRef = (0, react_1.useRef)();
  var self = (0, react_1.useRef)();
  var dataIsEmpty = data.length === 0;
  (0, react_1.useEffect)(function () {
    if (editable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editable]);
  var setFormGroupRef = (0, react_1.useCallback)(function (element) {
    formGroupRef.current = element;
  }, []);
  var handleBodyClick = (0, react_1.useCallback)(function (event) {
    if (!(formGroupRef.current && event.target)) {
      return;
    }
    if (formGroupRef.current && event.target) {
      var isClickInner = formGroupRef.current.contains(event.target);
      if (isClickInner && onlyLabelDisplay) {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      } else if (!isClickInner) {
        setEditable(false);
      }
    }
  }, [onlyLabelDisplay]);
  (0, react_1.useEffect)(function () {
    document.addEventListener('click', handleBodyClick);
    return function () {
      document.removeEventListener('click', handleBodyClick);
    };
  }, [handleBodyClick]);
  var handleInputClick = (0, react_1.useCallback)(function (event) {
    if (!editable && !disabled) {
      setEditable(true);
    }
    event.preventDefault();
  }, [disabled, editable]);
  var handleOnChange = (0, react_1.useCallback)(function (e, labels, payload, inputValue) {
    if (!onChange) {
      throw new Error("Invalid prop onChange supplied to ".concat(info_1["default"].componentName, "."));
    } else {
      onChange(e, labels, payload, inputValue);
    }
  }, [onChange]);
  var handleClearBtnClick = (0, react_1.useCallback)(function (event) {
    if (!disabled) {
      // TODO: 将操作数据写到event中，利于上层读取(先兼容当前 adp 遗留代码，后面再删除掉，直接从 onChange 的第三个参数获取)
      // eslint-disable-next-line no-param-reassign
      event.EventMode = 'CLEAR';
      handleOnChange(event, [], {
        type: 'CLEAR'
      }, inputValue);
      setInputErrorMsg(null);
    }
  }, [disabled, handleOnChange, inputValue]);
  var handleLabelsDelete = (0, react_1.useCallback)(function (event, val) {
    // TODO: 将操作数据写到event中，利于上层读取 (先兼容当前 adp 遗留代码，后面再删除掉，直接从 onChange 的第三个参数获取)
    // eslint-disable-next-line no-param-reassign
    event.EventMode = 'DELETE';
    // eslint-disable-next-line no-param-reassign
    event.EventValue = val;
    var tdata = data.filter(function (str) {
      return str !== val;
    });
    handleOnChange(event, tdata, {
      type: 'DELETE',
      operationValue: val
    }, inputValue);
    setInputErrorMsg(null);
    event.stopPropagation();
    event.preventDefault();
    event.nativeEvent.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }, [data, handleOnChange, inputValue]);
  var handleInputChange = (0, react_1.useCallback)(function (event) {
    var _a;
    var value = event.target.value;
    var ret = ((_a = self.current) === null || _a === void 0 ? void 0 : _a.isOnComposition) || value.length === 0 ? true : validate(value, data, 'CHANGE');
    setInputValue(value);
    setInputErrorMsg(ret === true ? null : ret);
    handleOnChange(event, data, {}, value);
  }, [validate, data, handleOnChange]);
  var transInputValueIntoLabelWithValue = (0, react_1.useCallback)(function (val) {
    var inputErrorMsg = '';
    var words = (0, utils_1.arrayDistinct)(val.split(separatorReg || separator));
    var newData = data;
    var unValidWords = [];
    var validWords = words.filter(function (originStr) {
      var str = originStr.trim();
      if (str.length === 0) {
        return false;
      }
      var ret = validate(str, newData, 'KEYDOWN');
      if (ret !== true) {
        if (!inputErrorMsg) {
          inputErrorMsg = ret;
        }
        unValidWords.push(str);
      } else {
        newData = newData.concat(str);
      }
      return ret === true;
    });
    if (validWords.length > 0) {
      // TODO: 将操作数据写到event中，利于上层读取 (先兼容当前 adp 遗留代码，后面再删除掉，直接从 onChange 的第三个参数获取)
      // eslint-disable-next-line no-param-reassign
      event.EventMode = 'KEYDOWN';
      // eslint-disable-next-line no-param-reassign
      event.EventValue = validWords;
      var valInput = (0, utils_1.arrayDistinct)(unValidWords).join(separator);
      handleOnChange(event, data.concat(validWords), {}, valInput);
      setInputValue(valInput);
      setInputErrorMsg(inputErrorMsg);
    } else {
      setInputErrorMsg(inputErrorMsg);
    }
  }, [separatorReg, separator, data, validate, handleOnChange]);
  var handleInputKeydown = (0, react_1.useCallback)(function (event) {
    var element = event.target;
    var val = element.value.trim();
    if (val && (event.keyCode === 32 || event.keyCode === 13)) {
      transInputValueIntoLabelWithValue(val);
      event.preventDefault();
    }
    if (!val && data.length > 0 && event.keyCode === 8) {
      handleOnChange(event, data.slice(0, data.length - 1), {}, '');
      event.preventDefault();
    }
  }, [transInputValueIntoLabelWithValue, data, handleOnChange]);
  (0, react_1.useEffect)(function () {
    if (blurTransValueIntoLabel && inputRef.current) {
      inputRef.current.addEventListener('blur', function () {
        if (inputErrorMsg) {
          setInputValue('');
        }
        transInputValueIntoLabelWithValue(inputValue);
      });
    }
  });
  var handleComposition = (0, react_1.useCallback)(function (event) {
    var _a;
    var isOnComposition = event.type !== 'compositionend';
    if (self.current && ((_a = self.current) === null || _a === void 0 ? void 0 : _a.isOnComposition) !== isOnComposition) {
      self.current.isOnComposition = isOnComposition;
      if (!isOnComposition) {
        handleInputChange(event);
      }
    }
  }, [handleInputChange]);
  var transInputValueIntoLabel = (0, react_1.useCallback)(function () {
    transInputValueIntoLabelWithValue(inputValue);
  }, [transInputValueIntoLabelWithValue, inputValue]);
  (0, react_1.useImperativeHandle)(ref, function () {
    return {
      transInputValueIntoLabel: transInputValueIntoLabel
    };
  }, [transInputValueIntoLabel]);
  return react_1["default"].createElement(spaui_1.FormGroup, __assign({
    htmlRef: setFormGroupRef,
    clear: clear && !dataIsEmpty,
    onClear: handleClearBtnClick,
    className: (0, classnames_1["default"])(fromGroupClassName, 'spaui-labels-form-group', {
      disabled: disabled
    }),
    error: editable ? inputErrorMsg : errorTips
  }, FormGroupProps), react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('spaui-labels-input', {
      editable: onlyLabelDisplay || editable,
      'only-label': onlyLabelDisplay,
      empty: dataIsEmpty
    }, className),
    onClick: handleInputClick
  }, react_1["default"].createElement("label", {
    className: (0, classnames_1["default"])('spaui-labels-input-wrapper', wrapperClassName)
  }, dataIsEmpty && !editable || onlyLabelDisplay ? react_1["default"].createElement("div", {
    className: "spaui-labels-input-placeholder"
  }, placeholder) : react_1["default"].createElement("div", {
    className: "spaui-labels-input-value"
  }, data.join(separator)), react_1["default"].createElement(spaui_1.Labels, __assign({
    clear: labelClear,
    data: data,
    setItemClassName: setItemClassName,
    className: (0, classnames_1["default"])('spaui-labels-input-labels', labelsClassName, {
      mini: size === 'mini'
    }),
    onDelete: handleLabelsDelete,
    onClear: handleClearBtnClick,
    disabled: disabled,
    tipRender: tipRender
  }, LabelsProps), react_1["default"].createElement("li", {
    className: "spaui-labels-input-group"
  }, react_1["default"].createElement("input", {
    onChange: handleInputChange,
    value: inputValue,
    className: "spaui-labels-input-box",
    placeholder: inputPlaceholder,
    onKeyDown: handleInputKeydown,
    ref: inputRef,
    onCompositionStart: handleComposition,
    onCompositionEnd: handleComposition,
    disabled: disabled
  }))), react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])('spaui-labels-input-border', borderClassName)
  }))));
};
(0, spaui_utils_1.setComponentMark)(LabelInputComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(LabelInputComponent));